import {
  ActionIcon,
  Box,
  Button,
  Flex,
  Text,
  Title,
  Tooltip
} from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { modals } from "@mantine/modals";
import { IconEdit, IconGift, IconPlus, IconTrash } from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_Row,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { _localization } from "../../../../../../config/location";
import { tblItemByCat } from "../../../../../../model/TblItem";
import {
  tblPromotion,
  tblPromotionItemGiftCommand,
} from "../../../../../../model/TblPromotion";
import ModalItemGiftEditDiscount from "../../Modals/ModalItemGiftEditDiscount";
import ModalDiscountToAll from "../../Modals/ModalItemPrimaryDiscountToAll";
import ModelItemEquivalentGift from "../../Modals/ModelItemEquivalentGift";
import ModalSearchItems from "../../Modals/SearchItems";

interface DataItemCodeOld {
  codeMain: string;
  value: string | null;
}

const TableItemGiftPromotion = ({
  form,
  dataInit,
  approveStatus,
}: {
  form: UseFormReturnType<tblPromotion, (values: tblPromotion) => tblPromotion>;
  dataInit: tblPromotionItemGiftCommand[];
  approveStatus: string;
}) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 25 });
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [itemCodeOld, setItemCodeOld] = useState<DataItemCodeOld[]>([]);
  const [data, setData] = useState<tblPromotionItemGiftCommand[]>([]);

  const entity: tblPromotionItemGiftCommand = {
    id: 0,
    promoteId: null,
    promoteDetailId: null,
    idItemPrimary: null,
    idItemGift: null,
    quantityApply: null,
    quantityMin: null,
    quantityMax: null,
    discountPercent: null,
    discountAmount: null,
    price: null,
    priceMin: null,
    priceMax: null,
    // attribute1: null,
    attribute2: null,
    // attribute3: null,
    // attribute4: null,
    // attribute5: null,
    // attribute6: null,
    // attribute7: null,
    // attribute8: null,
    // attribute9: null,
    // attribute10: null,
    // attribute11: null,
    // attribute12: null,
    // attribute13: null,
    // attribute14: null,
    // attribute15: null,
    itemGiftCode: null,
    itemGiftName: null,
  };

  const displayData = React.useMemo(() => {
    const flattened: any[] = [];
    // Tìm các sản phẩm cha (không có attribute2)
    const parents = data.filter((item) => !item.attribute2);

    parents.forEach((parent) => {
      flattened.push({
        ...parent,
        itemPrimaryCode: parent.itemPrimaryCode || parent.itemGiftCode,
        itemPrimaryName: parent.itemPrimaryName || parent.itemGiftName,
        isChild: false,
      });

      // Tìm các sản phẩm con của cha này (attribute2 === mã hàng cha)
      const parentCode = parent.itemGiftCode || parent.itemPrimaryCode;
      const children = data.filter(
        (item) => item.attribute2 === parentCode
      );

      children.forEach((child, index) => {
        flattened.push({
          ...child,
          isChild: true,
          parentCode: parentCode,
          childIndex: index,
        });
      });
    });
    return flattened;
  }, [data]);
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "itemPrimaryCode",
        header: "Mã hàng",
        size: 150,
        Cell: ({ row, renderedCellValue }) => (
          <Flex align="center" gap={4} pl={row.original.isChild ? 20 : 0}>
            {row.original.isChild && (
              <IconGift
                size={14}
                stroke={1.5}
                color="var(--mantine-color-blue-6)"
              />
            )}
            <Text size="11.5px" fw={row.original.isChild ? 400 : 600}>
              {renderedCellValue}
            </Text>
          </Flex>
        ),
      },
      {
        accessorKey: "itemPrimaryName",
        header: "Tên hàng",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label={renderedCellValue as string}>
            <Text
              truncate="end"
              w={row.original.isChild ? 480 : 500}
              size="11.5px"
              fs={row.original.isChild ? "italic" : "normal"}
            >
              {renderedCellValue}
            </Text>
          </Tooltip>
        ),
      },
      {
        accessorKey: "quantityApply",
        enableGlobalFilter: false,
        header: "SL cho phép",
        size: 80,
        Cell: ({ renderedCellValue }) => renderedCellValue,
      },
      {
        accessorKey: "quantityMax",
        header: "SLượng tối đa 1 lần được mua/1 Đ.Hàng",
        enableGlobalFilter: false,
        Cell: ({ renderedCellValue }) => renderedCellValue,
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableColumnActions: false,
        enableSorting: false,
        size: 100,
        enableGlobalFilter: false,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {processTaskActionMenu(row)}
          </Box>
        ),
      },
    ],
    [itemCodeOld, approveStatus, displayData, data]
  );

  function processTaskActionMenu(row: MRT_Row<any>) {
    if (row.original.attribute2) { // nếu có mã của thằng cha , tức sản phẩm là sản phẩm con
      return (
        <></>
      );
    }
    return (
      <>
        <Tooltip label="Quà tặng tương đương">
          <ActionIcon
            variant="light"
            aria-label="Settings"
            color="blue"
            onClick={() =>
              ModalItemEquivalentGift(
                row.original,
              )
            }
          >
            <IconGift size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Sửa chiết khẩu">
          <ActionIcon
            variant="light"
            aria-label="Settings"
            color="yellow"
            onClick={() =>
              openModalItemGiftEditDiscount(
                row.original,
                itemCodeOld.filter(
                  (i) => i.codeMain === row.original.itemPrimaryCode
                )[0]?.value
              )
            }
          >
            <IconEdit size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        {!row.original.isNotDelete ? (
          <Tooltip label="Xóa sản phẩm">
            <ActionIcon
              variant="light"
              aria-label="Settings"
              color="red"
              onClick={() => deletesData([row.id])}
            >
              <IconTrash size={14} stroke={1.5} />
            </ActionIcon>
          </Tooltip>
        ) : (
          <></>
        )}
      </>
    );
  }

  const openSearchItems = () => {
    modals.openConfirmModal({
      size: "70vw",
      centered: true,
      title: <Title order={5}>Tìm kiếm mặt hàng</Title>,
      children: <ModalSearchItems handleAddSearchItem={handleAddSearchItem} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const openModalDiscountToAll = () => {
    modals.openConfirmModal({
      size: "550px",
      title: <Title order={5}>Nhập chiết khấu</Title>,
      children: (
        <ModalDiscountToAll
          appleDiscountToAll={appleDiscountToAll}
          itemType="gift"
          typePromotion="1"
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const openModalItemGiftEditDiscount = (
    dataEdit: tblPromotionItemGiftCommand,
    listItemCodeOld: string | null
  ) => {
    modals.openConfirmModal({
      size: "700px",
      title: <Title order={5}>Nhập chiết khấu</Title>,
      children: (
        <ModalItemGiftEditDiscount
          dataEdit={dataEdit}
          editItemDiscount={editItemDiscount}
          approveStatus={approveStatus}
          listItemCodeOld={listItemCodeOld}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  const ModalItemEquivalentGift = (dataEdit: tblPromotionItemGiftCommand) => {
    // Lấy các sản phẩm con hiện có của sản phẩm này
    const currentSiblings = displayData.filter(item => String(item.attribute2) === String(dataEdit.itemPrimaryCode));
    modals.openConfirmModal({
      size: "auto",
      title: <Title order={5}>Quà tặng tương đương</Title>,
      children: (
        <ModelItemEquivalentGift
          dataEdit={dataEdit}
          currentSiblings={currentSiblings}
          editItemDiscount={editItemDiscountWithSiblings}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleAddSearchItem = (selectItem: tblItemByCat[]) => {
    const newData: tblPromotionItemGiftCommand[] = selectItem?.map((item) => ({
      ...entity,
      idItemGift: item.itemId,
      itemGiftCode: item.itemCode,
      itemGiftName: item.itemName,
      idItemPrimary: item.itemId,
      itemPrimaryCode: item.itemCode,
      itemPrimaryName: item.itemName,
      isChild: false,
    }));

    const addUniqueItems = (prevData: tblPromotionItemGiftCommand[]) => {
      const uniqueItemsMap = new Map<number, tblPromotionItemGiftCommand>();

      [...newData, ...prevData].forEach((item) => {
        if (item.idItemGift !== null) {
          uniqueItemsMap.set(item.idItemGift, item);
        }
      });
      return Array.from(uniqueItemsMap.values());
    };

    setData((prevData) => addUniqueItems(prevData));
    setRowCount((prevData) => prevData + selectItem.length);
    setSelectIds([]);
    table.resetRowSelection();
    modals.closeAll();
  };

  const appleDiscountToAll = (dataSubmit: {
    discountPercent: null;
    discountAmount: null;
    quantityMin: null;
    quantityMax: null;
  }) => {
    const select = table.getSelectedRowModel().rows.map((row) => row.original);

    if (select.length > 0) {
      setData((prevData) =>
        prevData.map((item) => {
          const selectedItem = select.find(
            (selected) => selected.idItemGift === item.idItemGift
          );
          return selectedItem ? { ...item, ...dataSubmit } : item;
        })
      );
    } else {
      setData((prevData) =>
        prevData.map((item) => ({ ...item, ...dataSubmit }))
      );
    }

    modals.closeAll();
    table.resetRowSelection();
  };

  const editItemDiscount = (dataSubmit: tblPromotionItemGiftCommand) => {
    console.log("dataSubmit", dataSubmit);
    setData((prevData) =>
      prevData.map((item) =>
        item.idItemGift === dataSubmit.idItemGift ? dataSubmit : item
      )
    );

    modals.closeAll();
  };
  // const editItemDiscountWithSiblings = (dataParent: tblPromotionItemGiftCommand, dataSiblings: tblPromotionItemGiftCommand[]) => {
  //   console.log("dataParent", dataParent);
  //   console.log("dataSiblings", dataSiblings);
  //   setData((prevData) => {
  //     // Giữ lại các item không liên quan đến parent này
  //     const otherItems = prevData.filter(
  //       (item) => item.idItemGift !== dataParent.idItemGift && item.attribute2 !== dataParent.itemPrimaryCode
  //     );

  //     // Thêm parent đã cập nhật và các siblings mới
  //     return [...otherItems, dataParent, ...dataSiblings];
  //   });

  //   modals.closeAll();
  // };
  const editItemDiscountWithSiblings = (dataParent: tblPromotionItemGiftCommand, dataSiblings: tblPromotionItemGiftCommand[]) => {
    console.log("dataParent", dataParent);
    console.log("dataSiblings", dataSiblings);
    const updateData = (prevData: tblPromotionItemGiftCommand[]) => {
      // 1. Tìm vị trí của thằng cha trong mảng hiện tại
      const parentIndex = prevData.findIndex(
        (item) => item.itemPrimaryCode === dataParent.itemPrimaryCode && !item.attribute2
      );

      // Nếu không tìm thấy cha (lỗi logic nào đó), cứ append vào cuối như cũ
      if (parentIndex === -1) {
        const otherItems = prevData.filter(
          (item) => item.idItemGift !== dataParent.idItemGift && item.attribute2 !== dataParent.itemPrimaryCode
        );
        return [...otherItems, dataParent, ...dataSiblings];
      }

      // 2. Lấy các phần tử đứng TRƯỚC thằng cha
      const before = prevData.slice(0, parentIndex);

      // 3. Lấy các phần tử đứng SAU thằng cha và LỌC BỎ các con cũ của cha này
      const after = prevData.slice(parentIndex + 1).filter(
        (item) => item.attribute2 !== dataParent.itemPrimaryCode
      );

      // 4. Ghép lại: [Trước] + [Cha mới] + [Các con mới] + [Sau]
      return [...before, dataParent, ...dataSiblings, ...after];
    };

    setData((prev) => updateData(prev));

    modals.closeAll();
  };

  const deletesData = (ids: string[]) => {
    setData((prevData) => {
      // 1. Xác định danh sách mã hàng của các sản phẩm cha bị xóa
      const parentCodesToDelete = prevData
        .filter(
          (item) =>
            !item.attribute2 && ids.includes(item.idItemGift?.toString() || "")
        )
        .map((item) => item.itemPrimaryCode || item.itemGiftCode);

      // 2. Lọc bỏ các phần tử:
      // - Nằm trong danh sách ids (xóa trực tiếp)
      // - Hoặc là con của một sản phẩm cha bị xóa (attribute2 nằm trong parentCodesToDelete)
      return prevData.filter((item) => {
        const itemGiftIdStr = item.idItemGift?.toString() || "";

        // Kiểm tra xem item có bị xóa trực tiếp không (khớp ID hoặc khớp prefix với hàng con)
        const isDirectlyDeleted = ids.some(
          (id) =>
            id === itemGiftIdStr || id.startsWith(`${itemGiftIdStr}_child_`)
        );

        // Kiểm tra xem item có phải là con của cha bị xóa không
        const isChildOfDeletedParent =
          item.attribute2 && parentCodesToDelete.includes(item.attribute2);
          
        return !isDirectlyDeleted && !isChildOfDeletedParent;
      });
    });

    setSelectIds([]);
    table.resetRowSelection();
  };

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (465 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    form.setFieldValue("tblPromotionItemGiftCommands", data);
  }, [data]);

  useEffect(() => {
    if (approveStatus === "1") {
      setData(dataInit);
    } else {
      const dataSet = dataInit.map((item) => ({
        codeMain: item.itemPrimaryCode || "",
        value: item.attribute2
          ? item.attribute2
          : null,
      }));

      setData(
        dataInit.map((item) => ({
          ...item,
          itemPrimaryCode: item.itemPrimaryCode || item.itemGiftCode,
          itemPrimaryName: item.itemPrimaryName || item.itemGiftName,
          isNotDelete: true,
        }))
      );

      setItemCodeOld(
        dataSet.map((item) => ({
          codeMain: item.codeMain,
          value:
            item.value && Array.isArray(item.value)
              ? item.value.map((i) => i.itemCode).join(",")
              : null,
        }))
      );
    }
    setRowCount(dataInit.length);
    form.setFieldValue("tblPromotionItemGiftCommands", dataInit);
  }, [dataInit]);

  const table = useMantineReactTable<any>({
    columns,
    data: displayData,
    positionToolbarAlertBanner: "bottom",
    mantineTableBodyRowProps: ({ row }) => ({
      style: {
        backgroundColor: row.original.isChild
          ? "var(--mantine-color-gray-0)"
          : "transparent",
      },
    }),
    renderTopToolbarCustomActions: ({ table }) => (
      <div ref={headerRef}>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Box></Box>
          {/* <Button
            leftSection={<IconSearch size={14} />}
            color="blue"
            variant="outline"
            onClick={async () => {
              // await fetchData();
            }}
          >
            Lọc bảng giá
          </Button> */}
        </Flex>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify={"flex-end"}
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Button
            leftSection={<IconPlus size={14} />}
            color="blue"
            variant="outline"
            onClick={openSearchItems}
          >
            Thêm mới (F11)
          </Button>

          <Button
            leftSection={<IconTrash size={14} />}
            color="red"
            variant="outline"
            onClick={() => {
              deletesData(selectIds);
            }}
            disabled={selectIds.length < 1}
          >
            Xóa (đã chọn)
          </Button>

          {approveStatus === "1" ? (
            <Button
              leftSection={<IconEdit size={14} />}
              color="green"
              variant="outline"
              onClick={() => openModalDiscountToAll()}
              disabled={data.length < 1}
            >
              Thiết lập chiết khấu
            </Button>
          ) : (
            <></>
          )}
        </Flex>
      </>
    ),
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: (row) => !row.original.isNotDelete && !row.original.isChild,
    enableRowVirtualization: true,
    enableBatchRowSelection: true,
    enablePagination: true,
    selectAllMode: "all",
    rowVirtualizerOptions: { overscan: 8 },
    getRowId: (row) =>
      row.isChild
        ? `${row?.idItemGift?.toString() || "null"}_child_${row.childIndex}`
        : row?.idItemGift?.toString() || Math.random().toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: [
          "mrt-row-select",
          "apply",
          "itemGiftCode",
          "namePurchase",
          "nameManufacturer",
        ],
        right: ["allocationRate", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
      showGlobalFilter: true,
    },
    enableGlobalFilter: true,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    // manualPagination: true,
    // manualSorting: true,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        // fontWeight: "bold",
        fontSize: "11px",
        padding: "4px 12px",
      },
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      // showProgressBars: isRefetching,
      // showSkeletons: isLoading, //loading for the first time with no data
      //   sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: false,
    mantineTableProps: {
      striped: false,
    },
  });

  return <MantineReactTable table={table} />;
};

export default TableItemGiftPromotion;
